import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
export const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, loading }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent><DialogContentText>{message}</DialogContentText></DialogContent>
    <DialogActions sx={{ p: 2, gap: 1 }}>
      <Button onClick={onCancel} disabled={loading}>Cancel</Button>
      <Button variant="contained" color="error" onClick={onConfirm} disabled={loading}>
        {loading ? 'Deleting...' : 'Confirm'}
      </Button>
    </DialogActions>
  </Dialog>
);
